<template>
  <div v-if="selected_user_obj" class="absolute">
    <img
      v-if="selected_user_obj?.avatar"
      class="inline-block h-20 -mt-32 object-cover"
      :src="$utils.extractUrl(selected_user_obj?.avatar)"
      alt="">
    <Avatar
      v-else
      :radius="62"
      class="relative bottom-24"
      :hover-effect="true"
      :first-name="selected_user_obj?.first_name"
      :last-name="selected_user_obj?.last_name" />
  </div>
  <div class="w-full flex space-x-2">
    <ComboBoxInput
      v-model="team_member_selected"
      :allow-null="false"
      class="w-full"
      :value="team_member_selected"
      name="selected_options_2"
      :items="$store.state.data.users"
      label-attr="full_name"
      value-attr="id"
      :is-box-background="true"
      :label="$t('Team member name')"
      input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-[10px] border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
      :placeholder="$t('Team member name')" />

    <TextInput
      :disabled="true"
      :validate-on-input="true"
      :value="selected_user_obj?.job_title"
      :label="$t('Job Title')"
      :classes="'w-full'"
      input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
      name="role"
      type="text"
      :placeholder="$t('Job Title')" />
  </div>
  <div class="relative flex mt-4 span-x-2 w-full z-10">
    <div class="w-full h-[120px] mt-0 border rounded-lg">
      <TextEditor
        :value="more_details"
        :show-label="true"
        toolbar="essential"
        :placeholder="$t('type here')"
        name="internal_description"
        :label="$t('Read more detail')"
        theme="bubble"
        input-classes="rounded-b-md"
        @changed="
          (e) => {
            more_details = e
          }
        " />
    </div>
  </div>

  <div class="grid grid-cols-2 w-full mt-3">
    <div class="col-span-1 mr-2 mt-4">
      <TextInput
        :validate-on-input="true"
        :disabled="true"
        :value="selected_user_obj?.linkedin_profile"
        :label="$t('Linkedin Page')"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="linkedin"
        type="text"
        :placeholder="$t('Linkedin Page')" />
    </div>
    <div class="col-span-1 mt-4">
      <TextInput
        :validate-on-input="true"
        :disabled="true"
        :value="selected_user_obj?.instagram_profile"
        :label="$t('Instagram Page')"
        :classes="'w-full'"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="instagram"
        type="text"
        :placeholder="$t('Instagram Page')" />
    </div>

    <div class="col-span-1 mr-2 mt-4">
      <TextInput
        :validate-on-input="true"
        :disabled="true"
        :value="selected_user_obj?.facebook_profile"
        :label="$t('Facebook Page')"
        :classes="'w-full'"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="facebook"
        type="text"
        :placeholder="$t('Facebook Page')" />
    </div>
    <div class="col-span-1 mt-4">
      <TextInput
        :validate-on-input="true"
        :disabled="true"
        :value="selected_user_obj?.phone_number"
        :label="$t('Phone Number')"
        :classes="'w-full'"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="phone_number"
        type="text"
        :placeholder="$t('Phone Number')" />
    </div>
    <div class="col-span-1 mr-2 mt-4">
      <TextInput
        :validate-on-input="true"
        :disabled="true"
        :value="selected_user_obj?.twitter_profile"
        :label="$t('Twitter Page')"
        :classes="'w-full'"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="instagram"
        type="text"
        :placeholder="$t('Twitter Page')" />
    </div>
    <div class="col-span-1 mt-4">
      <TextInput
        :validate-on-input="true"
        :disabled="true"
        :value="selected_user_obj?.personal_website"
        :label="$t('Website')"
        :classes="'w-full'"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="website"
        type="text"
        :placeholder="$t('Website')" />
    </div>
  </div>

  <label v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'" class="mt-3 ml-4">{{ $t("Show on") }}:</label>
  <SelectInput
    v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
    v-model="connect_to"
    :disabled="disabled_connect_to_selection"
    name="select_input"
    :allow-null="false"
    :items="connect_to_options"
    :is-box-background="true"
    :value="connect_to"
    label-attr="name"
    value-attr="value"
    :placeholder="$t('Connect to')"
    :label="$t('Connect to')"
    class="w-[200px]"
    input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />

  <div class="flex flex-row justify-between w-full gap-2 mt-10">
    <div class="w-1/2 m-0 cancel-btn" @click="is_loading ? null : $emit('cancel')">
      {{ $t("Cancel") }}
    </div>
    <button
      :class="[!team_member_selected || !team_member_selected ? 'opacity-50' : '']"
      :disable="!team_member_selected || !team_member_selected"
      type="button"
      class="w-1/2 primary-btn"
      @click="updateTeamCard()">
      {{ is_loading ? $t("Loading...") : teamCard ? $t("Update Team Member Card") : $t("Create Team Member Card") }}
    </button>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"

import TextInput from "@/components/shared/TextInput.vue"
import TextEditor from "@/components/shared/TextEditor.vue"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import Avatar from "@/components/shared/Avatar.vue"

export default {
  components: { SelectInput, TextInput, TextEditor, ComboBoxInput, Avatar },
  props: { teamCard: null },
  emits: ["setComponentData", "cancel", "submitForm"],
  data() {
    return {
      is_loading: false,
      team_member_selected: null,
      more_details: null,
      connect_to: "all_pages",
      connect_to_options: [
        { name: this.$t("All Pages"), value: "all_pages" },
        { name: this.$t("This Page"), value: "this_page" }
      ],
      page_identifier: "all",
      disabled_connect_to_selection: false
    }
  },

  computed: {
    selected_user_obj() {
      if (!this.team_member_selected) {
        return null
      }
      return this.$store.state.data.users.find((u) => u.id == this.team_member_selected)
    }
  },
  watch: {
    team_member_selected() {
      this.setComponentData()
    },
    more_details() {
      this.setComponentData()
    },
    connect_to() {
      if (this.connect_to == "this_page") {
        this.page_identifier = `${this.$route.params.object_type}>${this.$route.params.cid}`
      } else {
        this.page_identifier = "all"
      }
      this.setComponentData()
    }
  },

  created() {
    if (this.teamCard) {
      this.disabled_connect_to_selection = true
      if (typeof this.teamCard.props.component_props.label == "object") {
        this.connect_to = "this_page"
      }
      this.team_member_selected = this.$utils.extractValue(this.teamCard.props.component_props.team_member_selected, "", this.$route)
      this.more_details = this.$utils.extractValue(this.teamCard.props.component_props.more_details, "", this.$route)
    }
  },

  methods: {
    setComponentData() {
      this.$emit("setComponentData", {
        required_filled: this.team_member_selected,
        team_member_selected: this.team_member_selected,
        more_details: this.more_details,
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    },
    updateTeamCard() {
      this.$emit("submitForm", {
        id: this.teamCard?.id,
        component_type: "team_card",
        team_member_selected: this.team_member_selected,
        more_details: this.more_details,
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    }
  }
}
</script>
